<template>
    <div>
        <div class="flex w-full">
            <vx-input
                class="w-1/2 mr-4"
                v-model="patient.firstName"
                label="First Name"
                name="First Name"
                :rules="['required']"
                clearable
                autofocus
            />
            <vx-input
                class="w-1/2"
                v-model="patient.lastName"
                label="Last Name"
                name="Last Name"
                :rules="['required']"
                clearable
            />
        </div>

        <div class="flex w-full">
            <vx-button-switch
                class="w-1/2 mr-4"
                v-model="gender"
                label="Gender *"
                :options="genders"
                name="Gender"
                :rules="['required']"
            />

            <vx-medicare-card-input
                class="w-1/2"
                label="Medicare Number"
                v-model="patient.medicareNumber"
                remove-validation-padding
                medicare
            />
        </div>

        <div class="flex w-full">
            <vx-date-input
                class="w-1/2 mr-4"
                v-model="patient.dateOfBirth"
                label="Date of Birth"
                clearable
                :disabled="!!patient.id && !!patient.dateOfBirth"
                name="Date of Birth"
                :rules="['required']"
            />
            <div class="w-1/2">
                <!--Nothing in here, just for spacing-->
            </div>
        </div>
        <div class="flex w-full flex-nowrap">
            <div class="w-1/2 mr-2 mb-1" style="height: 77.34px">
                <vx-switch
                    v-model="patient.isDeceased"
                    class="w-full"
                    color="primary"
                    label="Deceased"
                    label-position="top"
                >
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                </vx-switch>
            </div>
            <vx-date-input
                v-if="patient.isDeceased"
                v-model="patient.dateOfDeath"
                class="w-1/2 ml-2"
                label="Date of Death"
                clearable
                :disabled="this.originalPatient && this.originalPatient.isDeceased"
            />
            <div v-else class="w-1/2"><!--Nothing in here, just for spacing--></div>
        </div>
        <div div class="flex w-full flex-nowrap">
            <div class="w-1/2 mr-2" style="height: 77.34px">
                <vx-switch
                    v-model="patient.hasPensionCard"
                    class="w-full"
                    color="primary"
                    label="Has Pension Card"
                    label-position="top"
                >
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                </vx-switch>
            </div>
            <vx-input
                v-if="patient.hasPensionCard"
                class="w-1/2 ml-2"
                v-model="patient.pensionCardNumber"
                label="Pension Card Number"
                clearable
            />
            <div v-else class="w-1/2"><!--Nothing in here, just for spacing--></div>
        </div>

        <div class="flex flex-col">
            <vx-radio
                v-model="indigenous"
                :options="indigenousOptions"
                text-key="description"
                value-key="id"
                color=""
                name="indigenous"
                label="Indigenous Declaration"
                vertical
                required
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'patient-details-section',
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            originalPatient: null,
            patient_x: {
                id: null,
                firstName: null,
                lastName: null,
                dateOfBirth: new Date(),
                genderId: null,
                indigenousId: 1,
                isDeceased: false,
                hasPensionCard: false,
                medicareNumber: null,
                dateOfDeath: null,
                pensionCardNumber: null
            },
            yesnoOptions: [
                {
                    id: 0,
                    name: 'No'
                },
                {
                    id: 1,
                    name: 'Yes'
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            genders: 'maarima/genders',
            indigenousOptions: 'maarima/indigenousOptions',
            getGenderById: 'maarima/getGenderById',
            getGenderByText: 'maarima/getGenderByText'
        }),
        rules_x() {
            return [this.validateIndegenous()]
        },
        patient: {
            get() {
                return this.form.patient
            },
            set(v) {
                if (!v) {
                    v = this.patient_x
                }
                this.$set(this.form, 'patient', v)
            }
        },
        gender: {
            get() {
                if (!this.patient) {
                    return null
                } else if (this.patient.genderId) {
                    return this.getGenderById(this.patient.genderId)
                }
                return this.patient.genderId
            },
            set(v) {
                if (!v) {
                    v = null
                } else if (typeof v == 'number') {
                    v = this.getGenderById(v.id)
                }
                this.patient.genderId = v.id
            }
        },
        indigenous: {
            get() {
                return this.patient.indigenousId
            },
            set(v) {
                this.patient.indigenousId = v
            }
        },
        isDeceased: {
            get() {
                if (this.patient.isDeceased) {
                    return this.yesnoOptions[1]
                }
                return this.yesnoOptions[0]
            },
            set(v) {
                this.patient.isDeceased = v.id
            }
        },
        hasPensionCard: {
            get() {
                if (this.patient.hasPensionCard) {
                    return this.yesnoOptions[1]
                }
                return this.yesnoOptions[0]
            },
            set(v) {
                this.patient.hasPensionCard = v.id
            }
        }
    },
    methods: {}
    // mounted() {
    //     this.patient = this.deepCopy(this.value)

    //     this.patient.diseases = this.patient.diseases.map((d) =>
    //         this.diseases.first((di) => di.id == d.id)
    //     )

    //     this.originalPatient = this.deepCopy(this.value)
    // }
}
</script>

<style lang="scss" scoped>
::v-deep .con-slot-tabs {
    height: 598px;
}
</style>
